import { Card, Col, Row } from 'antd';
import '../logiblockDashboard.scss';
import { CustomShipmentText } from '@/components';
import { ChartDataItem } from '@/pages/AiHistory/type';
import { ArrowDownOutlined, ArrowUpOutlined } from '@ant-design/icons';

interface LogiblockStatsProps {
  kpiData: ChartDataItem[];
}

const LogiblocksStats: React.FC<LogiblockStatsProps> = ({ kpiData }) => {
  return (
    <>
      <Row gutter={[12, 12]}>
        {kpiData.map((item, index) => (
          <Col
            key={index}
            className='lb-dashboard-cards-cols'
            xs={24}
            sm={24}
            md={24}
            lg={12}
            xl={6}
          >
            <Card key={index} className='lb-dashboard-stat-cards'>
              <CustomShipmentText
                text={item.title || ''}
                fontSize='14px'
                fontWeight={600}
              />
              <p className='count-wrapper'>
                {item.value ? `${item.value} ${item.unit || ''}` : '--'}
                {item?.change != null && item.change !== 0 && (
                  <span
                    className='subtext'
                    style={{
                      color: item?.is_negative
                        ? 'var(--danger)'
                        : 'var(--green-900)',
                    }}
                  >
                    {item.change < 0 ? (
                      <ArrowDownOutlined />
                    ) : (
                      <ArrowUpOutlined />
                    )}
                    {Math.abs(item.change)}%
                  </span>
                )}
              </p>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default LogiblocksStats;
